export default function Logo({ className, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 304 174"
      aria-label="WAABM.music logo"
      role="img"
      className={className}
      style={style}
    >
      <g transform="translate(0,174) scale(0.1,-0.1)" fill="currentColor" stroke="none">
        <path d="M145 1686 c-78 -35 -116 -130 -84 -213 16 -44 426 -452 477 -475 91
-41 190 13 211 116 l6 29 55 -58 c78 -81 129 -109 187 -102 51 5 88 29 121 77
21 32 22 40 22 277 0 280 -4 297 -75 338 -78 46 -166 25 -211 -50 l-25 -43 30
-48 c17 -26 29 -50 26 -53 -3 -2 -54 43 -113 101 -113 112 -143 128 -211 113
-38 -8 -87 -47 -106 -86 -14 -26 -13 -31 15 -75 16 -26 27 -50 25 -53 -3 -3
-52 41 -108 96 -125 125 -165 143 -242 109z"/>
        <path d="M1940 1619 c-63 -28 -770 -732 -808 -804 -34 -66 -37 -168 -6 -236
59 -127 198 -192 330 -154 55 16 69 27 236 193 98 96 181 173 184 169 3 -3
-16 -43 -44 -89 -49 -80 -50 -84 -37 -115 41 -98 145 -165 254 -164 102 0 136
22 321 206 91 91 169 165 173 165 15 0 6 -22 -36 -87 -24 -38 -46 -73 -50 -79
-10 -17 38 -108 73 -137 115 -97 258 -99 365 -5 27 24 58 64 71 93 24 50 24
51 24 456 l0 405 -26 52 c-49 99 -135 151 -248 152 -100 0 -140 -22 -276 -157
-63 -62 -115 -113 -116 -113 -1 0 -4 22 -8 48 -11 85 -80 170 -169 207 -52 22
-152 19 -207 -6z"/>
        <path d="M1100 85 l0 -45 905 0 905 0 0 45 0 45 -905 0 -905 0 0 -45z"/>
      </g>
    </svg>
  );
}
